import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=6dc13eee&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc13eee')) {
      api.createRecord('6dc13eee', component.options)
    } else {
      api.reload('6dc13eee', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=6dc13eee&", function () {
      api.rerender('6dc13eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/Edit.vue"
export default component.exports